(function () {
  if (window.palmrKlaviyoCartTracking || !window.fetch) return;
  window.palmrKlaviyoCartTracking = true;
  var originalFetch = window.fetch;
  var queue = Promise.resolve();

  function isCartAdd(input, options) {
    try {
      var url = new URL(typeof input === 'string' ? input : input.url || String(input), location.origin);
      var method = String(options && options.method || input && input.method || 'GET').toUpperCase();
      return method === 'POST' && url.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
    } catch (error) { return false; }
  }

  function isPaidItem(item) {
    return item && !(item.properties && item.properties._gift_tier) && Number(item.quantity) > 0;
  }

  function readCart(added, attempt) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return originalFetch.call(window, root + 'cart.js', {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    }).then(function (cart) {
      var valid = cart && Number.isFinite(cart.total_price) && cart.total_price > 0 && Array.isArray(cart.items) &&
        added.every(function (item) {
          return cart.items.some(function (line) {
            return String(line.variant_id || line.id) === String(item.variant_id || item.id) && isPaidItem(line);
          });
        });
      if (valid) return cart;
      if (attempt >= 2) return null;
      return new Promise(function (resolve) { setTimeout(resolve, 150 * (attempt + 1)); })
        .then(function () { return readCart(added, attempt + 1); });
    });
  }

  function track(response) {
    if (!response.ok) return Promise.resolve();
    return response.clone().json().then(function (result) {
      var added = (Array.isArray(result.items) ? result.items : [result]).filter(isPaidItem);
      if (!added.length) return;
      return readCart(added, 0).then(function (cart) {
        if (!cart) return;
        var item = added[0];
        var categories = [];
        cart.items.forEach(function (line) {
          if (line.product_type) categories.push(line.product_type);
          if (line.vendor) categories.push(line.vendor);
        });
        window._learnq = window._learnq || [];
        window._learnq.push(['track', 'Added to Cart', {
          $value: cart.total_price / 100,
          total_price: cart.total_price / 100,
          original_total_price: cart.original_total_price / 100,
          total_discount: cart.total_discount,
          items: cart.items,
          Categories: Array.from(new Set(categories)),
          ProductID: item.product_id,
          Name: item.product_title || item.title,
          URL: item.url ? location.origin + item.url : location.href,
          ImageURL: item.image && (item.image.src || item.image),
          CheckoutURL: location.origin + '/cart',
          tracking_source: 'palmr-confirmed-cart-v1'
        }]);
      });
    });
  }

  window.fetch = function (input, options) {
    var result = originalFetch.apply(this, arguments);
    if (isCartAdd(input, options)) {
      result.then(function (response) {
        var snapshot = response.clone();
        queue = queue.then(function () { return track(snapshot); }).catch(function () {});
      }).catch(function () {});
    }
    return result;
  };
}());
